import { readonly, ref } from 'vue'
import { acceptMyAgreement, getMyAgreement, type MyAgreement } from '@/services/agreements'

const agreement = ref<MyAgreement>()
const loading = ref(false)
const error = ref('')

export function useAgreement() {
  async function refresh() {
    loading.value = true
    error.value = ''
    try {
      agreement.value = await getMyAgreement()
      return agreement.value
    } catch (cause) {
      error.value = cause instanceof Error ? cause.message : 'Unable to load your portal agreement.'
      throw cause
    } finally {
      loading.value = false
    }
  }

  async function accept() {
    if (!agreement.value) await refresh()
    if (!agreement.value) throw new Error('Your agreement is unavailable.')
    loading.value = true
    error.value = ''
    try {
      agreement.value = await acceptMyAgreement(agreement.value.policy.version)
      return agreement.value
    } catch (cause) {
      error.value = cause instanceof Error ? cause.message : 'Unable to record your agreement.'
      throw cause
    } finally {
      loading.value = false
    }
  }

  return { agreement: readonly(agreement), loading: readonly(loading), error: readonly(error), refresh, accept }
}
